import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Layout from "../../../components/layout/Layout";

export default function UserSupportTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const { userId } = useParams();
  const navigate = useNavigate(null);

  const supportOptions = {
    0: "Order Issues",
    1: "Shipping & Delivery",
    2: "Returns & Refunds",
    3: "Payment Issues",
    4: "Contact Customer Service",
    5: "FAQs"
  };


  console.log("data UserId", userId);

  useEffect(() => {
    getSupports();
  }, []);

  // Fetching Data
  const getSupports = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("sansadToken");
      const headers = {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      };

      const response = await axios.get(
        `${process.env.REACT_APP_API_BASE_URL}/support/get-all-supports-for-user?userId=${userId}&status=`,
        {
          headers: headers,
        }
      );
      console.log("Response", response);
      if (response.data.statusCode === 200) {
        setData(response.data.result.supports);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <div>
      {/* Active supports */}
      <ToastContainer />
      <Layout>
        <div className="bg-white md:p-10 p-3 rounded-xl shadow-md mt-8">
          <div className="flex justify-between items-center">
            <h2 className="md:text-xl text-lg font-medium">Supports</h2>
            <div className="flex justify-center gap-4">
              <div className="">
                {/* <input
                type="text"
                className="md:h-[40px] h-[36px] md:w-[250px] w-[180px] rounded-xl border-2 border-gray-300 md:px-3 px-2 text-sm !outline-none"
                placeholder="Search Here..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              /> */}
              </div>
              {/* <div className="md:flex flex-col relative -top-1 hidden">
                <span className="text-xs mb-0.5">Per Page</span>
                <select
                  name="perPage"
                  id="perPage"
                  className="border border-[grey] rounded-md h-[22px] text-sm !outline-none"
                  value={recordsPerPage}
                  onChange={(e) => setRecordsPerPage(e.target.value)}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="30">30</option>
                  <option value="50">50</option>
                </select>
              </div> */}
            </div>
          </div>
          <div className="flex gap-4 justify-between flex-wrap mt-10 overflow-auto">
            <table className="w-full text-center">
              <thead>
                <tr className="border-b">
                  <td className="font-medium py-4 cursor-pointer">Id </td>

                  <td className="font-medium py-4 cursor-pointer">Email </td>
                  <td className="font-medium py-4 cursor-pointer">
                    Description{" "}
                  </td>
                  <td className="font-medium py-4 cursor-pointer">
                    Support Type{" "}
                  </td>
                  <td className="font-medium py-4 cursor-pointer">Order Id </td>
                  <td className="font-medium py-4 cursor-pointer">Status </td>
                  <td className="font-medium py-4 cursor-pointer">Actions </td>
                </tr>
              </thead>
              <tbody>
                {!loading ? (
                  data.length > 0 ? (
                    data.map((item) => (
                      <tr key={item._id} className={`border-b`}>
                        <td className="py-3 text-sm">{item._id}</td>
                        <td className="py-3 text-sm">{item?.userId.email}</td>
                        <td className="py-3 text-sm">
                          {item.description.length > 25
                            ? item.description.slice(0, 25) + "..."
                            : item?.description}
                        </td>
                        <td className="py-3 text-sm">{supportOptions[item.supportType]}</td>
                        <td className="py-3 text-sm">{item?.orderId?.orderId || "-"}</td>
                        <td className="py-3 text-sm">{item.status}</td>
                        <td className="py-3 text-sm flex justify-center gap-x-3">
                          <button
                            className="h-[36px] w-[36px] bg-[#01b208] rounded-full"
                            title="View Order"
                            onClick={() => {
                              navigate(
                                `/admin-panel/support/view-support/${item._id}`,
                                {
                                  state: { data: item },
                                }
                              );
                            }}
                          >
                            <i className="fa fa-eye text-white"></i>
                          </button>
                        </td>
                      </tr>
                    ))
                  ) : (
                    <td colSpan={7} className="text-center">
                      <p className="text-center w-full mt-10">
                        No results found
                      </p>
                    </td>
                  )
                ) : (
                  <td colSpan={7} className="text-center">
                    <p className="text-center w-full mt-10">Loading ...</p>
                  </td>
                )}
              </tbody>
            </table>
          </div>
        </div>
      </Layout>
    </div>
  );
}
